
import { defineComponent } from "vue";
import router from "@/router";
import EnrollmentsService from "@/api/Enrollment/IndividualEnrollmentService";
import { IIndividualEnrollmentModel } from "@/interfaces/modules";

export default defineComponent({
  name: "EnrollmentsList",
  data() {
    return {
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "StudentName", label: "Estudiante", sortable: true },
          { key: "HeadquarterName", label: "Sede", sortable: true },
          { key: "CourseGroupName", label: "Grupo", sortable: true },
          { key: "AcademicYearName", label: "Año académico", sortable: true },
          { key: "EnrollmentDateFormat", label: "Fecha matrícula", sortable: true },
          { key: "Status", label: "Estado", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as IIndividualEnrollmentModel[],
        rowsPerPage: 10,
      } as any,
    };
  },
  computed: {
    filteredItems(): IIndividualEnrollmentModel[] {
      const q = (this.table.filters.search || "").toLowerCase().trim();
      if (!q) return this.table.records;

      return this.table.records.filter((item: IIndividualEnrollmentModel) => {
        return [
          item.StudentName,
          item.CourseGroupName,
          item.AcademicYearName,
          item.Status,
          item.EnrollmentDate,
          String(item.Id),
        ]
          .filter(Boolean)
          .some((v) => String(v).toLowerCase().includes(q));
      });
    },
    rows(): number {
      return this.table.records?.length || 0;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await EnrollmentsService.GetEnrollments();
      this.table.loading = false;
    },
    editEnrollment(id: number) {
      router.push(`collection-account/${id}`);

    },
    enrollmentGroup() {
      router.push(`enrollment-group`);
    },
  },
});
